/**
 * 設定情報
 */
export const Settings = {
  TASK_LIST: {
    /** 作業競合確認の総合管理受付日時の開始日(N日前) */
    INITIAL_WORK_DAY: 7,
  },
};
